import { Injectable } from '@angular/core';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

@Injectable({
  providedIn: 'root'
})
export class ReportPdfService {

  async generateCertificatePdf(element: HTMLElement, fileName: string): Promise<void> {
    await this.waitForAssets(element);

    const canvas = await html2canvas(element, {
      backgroundColor: '#ffffff',
      scale: 2,
      useCORS: true,
      logging: false,
      width: element.scrollWidth,
      height: element.scrollHeight,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight
    });

    const imageData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'a4',
      compress: true
    });

    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    pdf.addImage(imageData, 'PNG', 0, 0, pageWidth, pageHeight, undefined, 'FAST');
    pdf.save(fileName);
  }

  private async waitForAssets(element: HTMLElement): Promise<void> {
    await Promise.all([
      this.waitForFonts(),
      this.waitForImages(element)
    ]);
  }

  private async waitForFonts(): Promise<void> {
    if ('fonts' in document) {
      await (document as Document & { fonts: FontFaceSet }).fonts.ready;
    }
  }

  private async waitForImages(element: HTMLElement): Promise<void> {
    const images = Array.from(element.querySelectorAll('img'));

    await Promise.all(images.map((image) => {
      if (image.complete) {
        return Promise.resolve();
      }

      return new Promise<void>((resolve) => {
        const complete = () => {
          image.removeEventListener('load', complete);
          image.removeEventListener('error', complete);
          resolve();
        };

        image.addEventListener('load', complete);
        image.addEventListener('error', complete);
      });
    }));
  }
}
